module.exports = __webpack_public_path__ + "static/img/02003C_C_2_3_4_5_6_7_20180407_fit.e2fb626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02003C_C_2_3_4_5_6_7_20180407_fit.png
// module id = MqFp
// module chunks = 0